import update from 'immutability-helper'
import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  CLEAR_BATCH_INFO,
  GET_BATCH_INFO,
  GET_BATCH_INFO_FAILURE,
  GET_BATCH_INFO_SUCCESS
} from '../actions/batchInfo'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  isLoading: false,
  wasLoaded: false,
  info: []
}

export default function batchInfo(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS
    case GET_BATCH_INFO:
      return update(state, {
        isLoading: { $set: true }
      })
    case GET_BATCH_INFO_SUCCESS:
      return update(state, {
        isLoading: { $set: false },
        info: { $set: action.batchInfoData },
        wasLoaded: { $set: true }
      })
    case GET_BATCH_INFO_FAILURE:
      return update(state, {
        isLoading: { $set: initialState.isLoading },
        info: { $set: initialState.info }
      })
    case CLEAR_BATCH_INFO:
      return update(state, { $set: initialState })
    default:
      return state
  }
}
